import { createSelector } from '@ngrx/store';
import * as staticDataState from '../static-data.reducer';
import * as asqEmployersReducer from '../reducers/asq-employers.reducer';

export const selectAsqEmployers = createSelector(
  staticDataState.selectAsqEmployersState,
  asqEmployersReducer.getAsqEmployers
);
